import styled from 'styled-components';

export const FooterSection = styled.footer`
  width: 100%;
  background: #111111;
  border-top: 1px solid rgba(255, 153, 0, 0.25);
  padding: 0;
`;

export const FooterInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 60px 24px 40px;
  display: flex;
  gap: 60px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
    padding: 40px 20px 30px;
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
  max-width: 220px;

  img {
    width: 140px;
    height: auto;
  }
`;

export const FooterTagline = styled.p`
  font-size: 0.88rem;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.5;
  margin: 0;
`;

export const FooterColumns = styled.div`
  display: flex;
  gap: 48px;
  flex: 1;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    gap: 32px;
  }
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 130px;
`;

export const FooterColumnTitle = styled.h4`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--primary-color);
  margin: 0 0 6px 0;
`;

export const FooterLink = styled.a`
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.2s ease;
  cursor: ${props => props.as === 'span' ? 'default' : 'pointer'};

  &:hover {
    color: var(--white-color);
  }

  &:focus-visible {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const FooterDivider = styled.hr`
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin: 0;
`;

export const FooterBottom = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FooterCopyright = styled.p`
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.3);
  margin: 0;
  text-align: center;
`;
